export const defaultMusicTrackId = "spooky-boop-otis-mcdonald";
export const musicTrackOptions = [
    {
        id: "bit-coin-otis-mcdonald",
        label: "Bit Coin - Otis Mcdonald",
        assetKey: "assets/audio/music/bit-coin-otis-mcdonald.mp3",
        durationInSeconds: 20,
        feelsLike: ["Energetic", "Curious", "Quirky"],
    },
    {
        id: "cant-hide-otis-mcdonald",
        label: "Can't Hide - Otis Mcdonald",
        assetKey: "assets/audio/music/cant-hide-otis-mcdonald.mp3",
        durationInSeconds: 20,
        feelsLike: ["Funky", "Educational", "Playful"],
    },
    {
        id: "forest-find-tracktribe",
        label: "Forest Find - TrackTribe",
        assetKey: "assets/audio/music/forest-find-tracktribe.mp3",
        durationInSeconds: 5,
        feelsLike: ["Fascinating", "Casual", "Fun"],
    },
    {
        id: "forever-young-otis-mcdonald",
        label: "Forever Young - Otis Mcdonald",
        assetKey: "assets/audio/music/forever-young-otis-mcdonald.mp3",
        durationInSeconds: 11,
        feelsLike: ["Playful", "Lighthearted", "Quirky"],
    },
    {
        id: "hello-mr-princeton-otis-mcdonald",
        label: "Hello Mr. Princeton - Otis Mcdonald",
        assetKey: "assets/audio/music/hello-mr-princeton-otis-mcdonald.mp3",
        durationInSeconds: 19,
        feelsLike: ["Funky", "Danceable"],
    },
    {
        id: "rest-otis-mcdonald",
        label: "Rest - Otis Mcdonald",
        assetKey: "assets/audio/music/rest-otis-mcdonald.mp3",
        durationInSeconds: 10,
        feelsLike: ["Spatial", "Active", "Synth"],
    },
    {
        id: "smoke-lish-grooves",
        label: "Smoke - Lish Grooves",
        assetKey: "assets/audio/music/smoke-lish-grooves.mp3",
        durationInSeconds: 11,
        feelsLike: ["Casual", "Educational"],
    },
    {
        id: "spooky-boop-otis-mcdonald",
        label: "Spooky Boop - Otis Mcdonald",
        assetKey: "assets/audio/music/spooky-boop-otis-mcdonald.mp3",
        durationInSeconds: 20,
        feelsLike: ["Funky", "Curious", "Dreamy"],
    },
    {
        id: "truckee-otis-mcdonald",
        label: "Truckee - Otis Mcdonald",
        assetKey: "assets/audio/music/truckee-otis-mcdonald.mp3",
        durationInSeconds: 10,
        feelsLike: ["Casual", "Downbeat", "Momentum"],
    },
    {
        id: "we-cruising-otis-mcdonald",
        label: "We Cruising - Otis Mcdonald",
        assetKey: "assets/audio/music/we-cruising-otis-mcdonald.mp3",
        durationInSeconds: 20,
        feelsLike: ["Bright", "Playful", "Informative"],
    },
    {
        id: "woodshedder-quincas-moreira",
        label: "Woodshedder - Quincas Moreira",
        assetKey: "assets/audio/music/woodshedder-quincas-moreira.mp3",
        durationInSeconds: 9,
        feelsLike: ["Laidback", "Casual"],
    },
    {
        id: "yesterday-otis-mcdonald",
        label: "Yesterday - Otis Mcdonald",
        assetKey: "assets/audio/music/yesterday-otis-mcdonald.mp3",
        durationInSeconds: 11,
        feelsLike: ["Funky", "Upbeat"],
    },
    {
        id: "spooky-horror-music-trapxmxr",
        label: "Spooky Horror Music - Trapxmxr",
        assetKey: "assets/audio/music/spooky-horror-music-trapxmxr.mp3",
        durationInSeconds: 59,
        feelsLike: ["Spooky", "Intriguing", "Suspenseful"],
    },
    {
        id: "alias-anno-domini-beats",
        label: "Alias - Anno Domini Beats",
        assetKey: "assets/audio/music/alias-anno-domini-beats.mp3",
        durationInSeconds: 27,
        feelsLike: ["Dark", "Trap", "Synth"],
    },
    {
        id: "kayak-the-grey-room-density-and-time",
        label: "Kayak - The Grey Room / Density & Time",
        assetKey: "assets/audio/music/kayak-the-grey-room-density-and-time.mp3",
        durationInSeconds: 31,
        feelsLike: ["Mysterious", "Cinematic", "Synth"],
    },
    {
        id: "alone-emmit-fenn",
        label: "Alone - Emmit Fenn",
        assetKey: "assets/audio/music/alone-emmit-fenn.mp3",
        durationInSeconds: 27,
        feelsLike: ["Curious", "Calm"],
    },
    {
        id: "no-4-piano-journey-esther-abrami",
        label: "No.4 Piano Journey - Esther Abrami",
        assetKey: "assets/audio/music/no-4-piano-journey-esther-abrami.mp3",
        durationInSeconds: 31,
        feelsLike: ["Motivational", "Inspiring", "Melancholic"],
    },
    {
        id: "candy-apple-town-national-sweetheart",
        label: "Candy Apple Town - National Sweetheart",
        assetKey: "assets/audio/music/candy-apple-town-national-sweetheart.mp3",
        durationInSeconds: 28,
        feelsLike: ["Melancholic", "Dreamy", "Acoustic"],
    },
    {
        id: "sofa-dyalla",
        label: "Sofa - Dyalla",
        assetKey: "assets/audio/music/sofa-dyalla.mp3",
        durationInSeconds: 23,
        feelsLike: ["Groovy", "Lo-fi", "Chill"],
    },
    {
        id: "deep-space-sector-9-ezra-lipp",
        label: "Deep Space Sector 9 - Ezra Lipp",
        assetKey: "assets/audio/music/deep-space-sector-9-ezra-lipp.mp3",
        durationInSeconds: 18,
        feelsLike: ["Dramatic", "Intense", "Cinematic"],
    },
    {
        id: "surface-of-the-moon-john-patitucci",
        label: "Surface of the Moon - John Patitucci",
        assetKey: "assets/audio/music/surface-of-the-moon-john-patitucci.mp3",
        durationInSeconds: 35,
        feelsLike: ["Mysterious", "Scary", "Ambient"],
    },
    {
        id: "forever-ever-patrick-patrikios",
        label: "Forever ever - Patrick Patrikios",
        assetKey: "assets/audio/music/forever-ever-patrick-patrikios.mp3",
        durationInSeconds: 33,
        feelsLike: ["Funky", "Upbeat"],
    },
    {
        id: "triumphant-aylex",
        label: "Triumphant - Aylex",
        assetKey: "assets/audio/music/triumphant-aylex.mp3",
        durationInSeconds: 20,
        feelsLike: ["Curious", "Motivational", "Chill"],
    },
    {
        id: "future-anno-domini-beats",
        label: "Future - Anno Domini Beats",
        assetKey: "assets/audio/music/future-anno-domini-beats.mp3",
        durationInSeconds: 15,
        feelsLike: ["Hot", "Trap"],
    },
    {
        id: "turn-in-the-sun-simon-herody",
        label: "Turn In The Sun - Simon Herody",
        assetKey: "assets/audio/music/turn-in-the-sun-simon-herody.mp3",
        durationInSeconds: 25,
        feelsLike: ["Emotional", "Chill", "Intriguing"],
    },
    {
        id: "future-glider-brian-bolger",
        label: "Future Glider - Brian Bolger",
        assetKey: "assets/audio/music/future-glider-brian-bolger.mp3",
        durationInSeconds: 39,
        feelsLike: ["Intriguing", "Cinematic", "Suspenseful"],
    },
    {
        id: "way-back-home-simon-herody",
        label: "Way Back Home - Simon Herody",
        assetKey: "assets/audio/music/way-back-home-simon-herody.mp3",
        durationInSeconds: 42,
        feelsLike: ["Emotional", "Uplifting", "Soft"],
    },
    {
        id: "ghibli-station-the-mini-vandals",
        label: "Ghibli Station - The Mini Vandals",
        assetKey: "assets/audio/music/ghibli-station-the-mini-vandals.mp3",
        durationInSeconds: 28,
        feelsLike: ["Curious", "Quirky", "Wonderous"],
    },
    {
        id: "way-back-when-patrick-patrikios",
        label: "Way back when - Patrick Patrikios",
        assetKey: "assets/audio/music/way-back-when-patrick-patrikios.mp3",
        durationInSeconds: 26,
        feelsLike: ["Funky", "Quirky"],
    },
];
